import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, TextField, Tooltip, Typography } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { useSnackbar } from 'notistack';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ConfirmDialogList from '../../../../../components/ConfirmDialogList';
import configSiteUrls from '../../../configs/configSiteUrls';
import { ISpublicacaoOficial, PublicacaoOficial, PublicacaoOficialDTO, PublicacaoOficialList } from '../types/PublicacaoOficial';
import { useDeletePublicacaoOficialMutation, useGetPublicacaoOficiaisQuery } from './publicacaoOficialApiSlice';
import { TabelaBase } from '../../../../../components/formControls/TabelaBase';

interface Props {
  publicacaoOficiais: PublicacaoOficialList[];
  handleExcluirtClick: (rowData: PublicacaoOficialList) => void;
  // Se quiser, também um handleEditClick ou baseEditUrl para link
  baseEditUrl?: string;
}

export const PublicacaoOficialDataTable = ({ publicacaoOficiais, handleExcluirtClick, baseEditUrl }: Props) => {
  // Renderizadores podem ficar dentro do componente
  const renderExercicio = (rowData: PublicacaoOficialList) => {
    //const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy') : 'Data não disponível';
    return (
      <Typography color="secondary" variant="body2">
        {rowData.exercicio !== null ? rowData.exercicio : 'N/A'}
      </Typography>
    );
  };

  const renderUsuario = (rowData: PublicacaoOficialList) => (
    <Typography color="secondary" variant="body2">
      {rowData.usuario?.nome || 'Usuário não disponível'}
    </Typography>
  );

  const renderDescricao = (rowData: PublicacaoOficialList) => (
    <Typography color="secondary" variant="body2">
      {rowData.descricao || ''}
    </Typography>
  );

  const renderTipo = (rowData: PublicacaoOficialList) => (
    <Typography color="secondary" variant="body2">
      {rowData.tipo?.nome || ''}
    </Typography>
  );

  const renderAction = (rowData: PublicacaoOficialList) => (
    <Box display="flex" gap={1}>
      <Tooltip title="Editar">
        {baseEditUrl ? (
          <Link to={`${baseEditUrl}${rowData.id}`}>
            <IconButton color="secondary" aria-label="edit">
              <EditIcon />
            </IconButton>
          </Link>
        ) : (
          <IconButton color="secondary" aria-label="edit">
            {/* Se quiser, pode passar um handleEditClick aqui */}
            <EditIcon />
          </IconButton>
        )}
      </Tooltip>

      <Tooltip title="Excluir">
        <IconButton color="secondary" aria-label="delete" onClick={() => handleExcluirtClick(rowData)}>
          <GridDeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );

  const columns = [
    { header: 'Exercício', body: renderExercicio, sortable: true, filter: false, filterPlaceholder: 'Filtrar por data', style: { width: 'auto' }, frozen: false },
    { header: 'Tipo', body: renderTipo, sortable: true, filter: false, filterPlaceholder: 'Filtrar por tipo', style: { width: '15%' } },
    { header: 'Descrição', body: renderDescricao, sortable: true, filter: false, filterPlaceholder: 'Filtrar por descrição', style: { width: '40%' } },
    { header: 'Usuário', body: renderUsuario, sortable: true, filter: false, filterPlaceholder: 'Filtrar por usuário', style: { width: 'auto' } },
    { header: 'Ações', body: renderAction, style: { width: 'auto' } }
  ];

  const headerGerados = (
    <Typography variant="body2" color="textSecondary">
      Registro(s) encontrado(s): {publicacaoOficiais.length}
    </Typography>
  );

  return (
    <>
      <TabelaBase
        value={publicacaoOficiais}
        columns={columns}
        dataKey="id"
        header={headerGerados}
        rows={25}
        paginator
        exportCSV={false}
        scrollable
        scrollHeight="500px"
        frozenWidth="150px"
        themeClassName="meu-tema-customizado"
      />
    </>
  );
};